export default __webpack_public_path__ + "static/sensor-overview-clip.hevc-dc0bdc9164bc650d66e15c536304b2da.mp4";